module.exports = __webpack_public_path__ + "static/media/Other-Vehicle-Icon.1d1c5a94.svg";